module.exports = __webpack_public_path__ + "media/images/pwa/safari_share-bbc23a7213537981eaf3b94170006957.png";